import { REFUND_ACTIONS, REFUND_ACTIONS_TXT } from '../constants/refundLogRow';
import { localeStore } from '~/mobx/localesStore';

export const getCellText = (txt: any): string => {
  if (!txt) {
    return '-';
  }

  return txt;
};

export const getRefundTypeTxt = (type: REFUND_ACTIONS | null) => {
  if (type === null) {
    return '-';
  }

  return localeStore.t(REFUND_ACTIONS_TXT[type]);
};

export const getAmount = (amount: number, currency: string | null): string => {
  return `${currency ?? ''} ${amount}`;
};
